import classNames from 'classnames';
import { ReactNode } from 'react';

import styles from './LayoutContent.module.css';

type LayoutContentProps = {
    children: ReactNode;
    width: 'narrow' | 'normal' | 'wide';
    id?: string;
    className?: string;
    noTopMargin?: boolean;
};

const LayoutContent = ({
    children,
    className,
    width,
    id,
    noTopMargin,
}: LayoutContentProps) => {
    const classes = classNames(styles.Root, className, {
        [styles.narrow]: width === 'narrow',
        [styles.normal]: width === 'normal',
        [styles.wide]: width === 'wide',
        [styles.noTopMargin]: noTopMargin,
    });

    return (
        <div className={classes} id={id}>
            {children}
        </div>
    );
};

export default LayoutContent;
